/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AbstractFinderDialogComponent } from '@gh/common-internal-shared';

import {
  createDialogRoute,
  FormState,
  FormStateBuilder,
  getDialogInitData,
} from '@gh/common-shared';
import { memoryBasedSlicedDataSource, SlicedDataSource } from '@gh/core-data';
import { LocalizationService, TranslationService } from '@gh/core-mls';
import { getControlValue } from '@gh/core-ui';

import {
  PrinterFinderBusinessService,
  PrinterFinderDialogConfig,
} from '../../resources/printer-finder-business.service';
import {
  getPrinterFinderListItemId,
  PrinterFinderListItem,
} from '../../resources/printer-finder.model';
import { PrinterFinderGridDefinition } from './printer-finder-grid-definition.service';

@Component({
  standalone: false,
  selector: 'gh-printer-finder-dialog',
  templateUrl: 'printer-finder-dialog.component.html',
  styleUrls: ['printer-finder-dialog.component.scss'],
  providers: [PrinterFinderGridDefinition],
})
export class PrinterFinderDialogComponent
  extends AbstractFinderDialogComponent<PrinterFinderDialogConfig, PrinterFinderListItem>
  implements OnInit {

  form: FormState<any>;
  getId = getPrinterFinderListItemId;

  defaultTitle = this.translations.get('lbl_find_printer');
  printers: PrinterFinderListItem[];

  constructor(@Inject(MAT_DIALOG_DATA) private dialogData: any,
              public gridDefinition: PrinterFinderGridDefinition,
              private localizationService: LocalizationService,
              private translations: TranslationService,
              private formStateBuilder: FormStateBuilder,
              private dialogRef: MatDialogRef<any>) {
    super(dialogRef);
  }

  ngOnInit(): void {
    this.form = this.formStateBuilder.buildPlain({
      children: {
        searchString: void 0,
      },
    });

    super.ngOnInit();
  }

  protected buildDataSource(): SlicedDataSource<PrinterFinderListItem> {
    const printers: PrinterFinderListItem[] = getDialogInitData(this.dialogData);
    const name = getControlValue(this.form.group, 'searchString');
    const locHelper = this.localizationService.getStringL10nHelper();
    return memoryBasedSlicedDataSource(name
      ? printers.filter(({ cloudPrinterName }) => locHelper.includesIgnoreCase(cloudPrinterName, name))
      : printers);
  }
}

export const printerFinderDialogRoute = createDialogRoute({
  component: PrinterFinderDialogComponent,
  init: PrinterFinderBusinessService,
  config: { width: '800px', height: '600px' },
});
